import { useEffect, useRef, useState } from "react";
import { RegulifyService } from "../api/RegulifyService";
import Message from "../components/Message";
import DeviceTable from "../components/DeviceTable";

import { useShallow } from "zustand/react/shallow";
import { useLoading } from "../context/LoadingContext";
import { useChatStore } from "../store/useChatStore";
import { useDeviceStore } from "../store/useDeviceSelectionFromLocator";

const PDLocator = () => {
  // const [tableData, setTableData] = useState([]);
  const devices = useDeviceStore((state) => state.devices);
  const setDevices = useDeviceStore((state) => state.setDevices);
  const lastQuery = useDeviceStore((state) => state.lastQuery);
  const setLastQuery = useDeviceStore((state) => state.setLastQuery);

  const [product_description, setProductDescription] = useState("");
  const messages = useChatStore(useShallow((state) => state.pdMessages));
  const newMessage = useChatStore((state) => state.newPDMessage);
  const chatRef = useRef(null);
  const { setLoading } = useLoading();

  const sendMessage = async (ev) => {
    ev.preventDefault();

    if (!product_description.trim()) return;

    const userMessage = {
      text: [product_description]
        .filter(Boolean)
        .join("\n\n"),
      sender: "Human",
    };
    newMessage(userMessage);

    try {
      setLoading(true);
      try {
  setLoading(true);

        const response = await RegulifyService.pdd_locate_devices(
          product_description
        );

        setDevices(response.data.results); 

      } catch (error) {
        console.error("Error:", error);
      }

      // const botMessage = { text: response.data, sender: "Bot" };
      // newMessage(botMessage);
    } catch (error) {
      console.error("Error:", error);
      const errorMessage = {
        text: "Failed to get a response. Please try again.",
        sender: "Bot",
      };
      newMessage(errorMessage);
    }
    setLoading(false);
    setLastQuery(product_description);
    setProductDescription("");
  };

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="flex h-[calc(100vh-180px)] w-full flex-col">
      <div className="card bg-base-100 mt-1 flex flex-1 flex-col overflow-hidden p-1 shadow-xl">
      <div
          ref={chatRef}
          className="flex min-h-0 flex-1 flex-col space-y-2 overflow-y-auto p-2"
        >
        {devices.length > 0 ? (
            <>
              {devices.length > 0 && lastQuery && (
                <div className="mb-2 text-sm font-medium text-gray-700">
                Potential Predicates for Device Description: "{lastQuery}"
              </div>
              )}
              <DeviceTable data={devices} />
            </>
          ) : (
          <div className="text-sm text-gray-500">
            No data yet. Submit a query.
          </div>
        )}
        </div>

        <div className="bg-base-100 mt-2 w-full flex-shrink-0">
          <form onSubmit={sendMessage} className="flex flex-col space-y-2">
            <fieldset className="fieldset bg-base-200 border-base-300 rounded-box w-full border p-4">
              <label className="fieldset-label">
                Device Description (Outline indications for use (diagnosis,
                treatment, prevention of disease, or impact on body
                structure/function) and technological characteristics in 3-7
                lines.)
              </label>
              <textarea
                placeholder="Enter device description"
                className="textarea w-full"
                value={product_description}
                onChange={(e) => setProductDescription(e.target.value)}
                rows={4}
              />
            </fieldset>
            <div className="mt-1">
              <button className="btn join-item" type="submit">
                Send
              </button>           
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PDLocator;
